"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.addTemporaryIdsToDoc = exports.mapDoc = void 0;
var constants_1 = require("./constants");
exports.mapDoc = function (doc, onNode) {
    var schema = doc.type.schema;
    var innerMap = function (node) {
        if (node.type.name === "text") {
            var copy_1 = schema.text(node.text, node.marks);
            return copy_1;
        }
        var content = [];
        if (node.childCount) {
            for (var i = 0; i < node.childCount; i++) {
                var child = innerMap(node.child(i));
                content.push(child);
            }
        }
        var copy = node.type.create(node.attrs, content);
        return onNode(copy);
    };
    return innerMap(doc);
};
var defaultIdGenerator = function () { return "r" + Math.round(Math.random() * 1e10).toString(); };
exports.addTemporaryIdsToDoc = function (doc, idAttrKey, idGenerator) {
    if (idAttrKey === void 0) { idAttrKey = constants_1.DEFAULT_ID_ATTR_KEY; }
    if (idGenerator === void 0) { idGenerator = defaultIdGenerator; }
    return exports.mapDoc(doc, function (node) {
        var _a;
        var spec = node.type.spec;
        if (spec.attrs && spec.attrs[idAttrKey] && node.attrs && !node.attrs[idAttrKey]) {
            node.attrs = __assign(__assign({}, node.attrs), (_a = {}, _a[idAttrKey] = idGenerator(), _a));
        }
        return node;
    });
};
